import React from 'react';
import styles from './OnboardingProgressIndicator.module.css';
import CheckIconSvg from '../../images/svg/check.svg';
import PaymentSvg from '../../images/svg/payment.svg';
import StarSvg from '../../images/svg/star.svg';
import ProfileSvg from '../../images/svg/profile.svg';

export enum OnboardingStep {
  RegisterAccount,
  AddingPayment,
  SettingPrivacySettings,
}

export function OnboardingProgressIndicator({
  onboardingStep,
}: {
  onboardingStep: OnboardingStep;
}) {
  let accountIconStyle = styles.pendingIconColor;
  let paymentIconStyle = styles.pendingIconColor;
  const lastIconStyle = styles.pendingIconColor;

  let firstLineStyle = styles.connectingLineBlack;
  let secondLineStyle = styles.connectingLineBlack;
  if (onboardingStep === OnboardingStep.AddingPayment) {
    accountIconStyle = styles.successIconColor;
    firstLineStyle = styles.connectingLineHalfGreen;
  } else if (onboardingStep === OnboardingStep.SettingPrivacySettings) {
    accountIconStyle = styles.successIconColor;
    firstLineStyle = styles.connectingLineGreen;
    paymentIconStyle = styles.successIconColor;
    secondLineStyle = styles.connectingLineHalfGreen;
  }

  return (
    <div className="flex flex-row items-center mb-8">
      <div className={`${styles.roundedIcon} ${accountIconStyle}`}>
        {onboardingStep === OnboardingStep.AddingPayment ? (
          <CheckIconSvg />
        ) : (
          <ProfileSvg />
        )}
      </div>
      <div className={firstLineStyle} />
      <div className={`${styles.roundedIcon} ${paymentIconStyle}`}>
        {onboardingStep === OnboardingStep.SettingPrivacySettings ? (
          <CheckIconSvg />
        ) : (
          <PaymentSvg />
        )}
      </div>
      <div className={secondLineStyle} />
      <div className={`${styles.roundedIcon} ${lastIconStyle}`}>
        <StarSvg />
      </div>
    </div>
  );
}
